import dayjs from "dayjs";

/** Default date range: 4 weeks ending this week's Friday. */
export const getDefaultDateRange = () => {
  const end = getThisWeeksFriday();
  const start = end.subtract(4, "week").add(1, "day");
  return {
    start: start.format("YYYY-MM-DD"),
    end: end.format("YYYY-MM-DD"),
  };
};

/** Friday of the current ISO week (Mon–Sun). */
export const getThisWeeksFriday = () => {
  const now = dayjs();
  const dayOfWeek = now.day();
  const daysSinceMonday = (dayOfWeek + 6) % 7;
  const monday = now.subtract(daysSinceMonday, "day");
  return monday.add(4, "day").startOf("day");
};

export const getLastWeekEndingDate = () => {
  return getThisWeeksFriday().subtract(1, "week").format("YYYY-MM-DD");
};

export const getWeekEndingDate = () => {
  return getThisWeeksFriday().format("YYYY-MM-DD");
};

export const getWeekEndingDateBy = (date) => {
  const dayOfWeek = dayjs(date).day();
  const daysSinceSunday = (dayOfWeek + 1) % 7;
  const friday = dayjs(date).add(6 - daysSinceSunday, "day");
  return friday.startOf("day").format("YYYY-MM-DD");
};

export const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  try {
    const datestr = new Date(dateString).toUTCString();
    return (
      datestr.substring(8, 11) +
      " " +
      +datestr.substring(5, 7) +
      ", " +
      datestr.substring(12, 16)
    );
  } catch {
    return dateString;
  }
};

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  }).format(amount);
};

export const formatNumber = (num, minDecimals = 0, maxDecimals = 2) => {
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: minDecimals,
    maximumFractionDigits: maxDecimals,
  }).format(num);
};

/** Renders null if value is not a number; otherwise format(number). Zero is valid and renders as 0. */
export const checkIfNumber = (num) => {
  const n = num != null && num !== "" ? Number(num) : NaN;
  return Number.isNaN(n) ? false : true;
};

export const formatPayRate = (rate) => {
  if (rate === null || rate === undefined) return "N/A";
  return `$${Number(rate).toFixed(2)}`;
};

export const formatTenure = (days) => {
  if (days === null || days === undefined) return "N/A";
  if (days < 7) return `${days} day${days !== 1 ? "s" : ""}`;
  if (days < 30) {
    const weeks = (days / 7).toFixed(1);
    return `${weeks} week${weeks !== "1.0" ? "s" : ""}`;
  }
  const months = (days / 30).toFixed(1);
  return `${months} month${months !== "1.0" ? "s" : ""}`;
};
